import { createAsyncThunk } from "@reduxjs/toolkit";

import { setSsrCalcTypes } from "slices/books/booksSlice";

export const fetchSsrCalcsTypes = createAsyncThunk("books/fetchSsrCalcsTypes", async (arg, { rejectWithValue, extra, dispatch, getState }) => {
	const state = getState();
	const ssrCalcsTypes = state.books.ssrCalcsTypes;

	if (ssrCalcsTypes && ssrCalcsTypes?.length > 0) return;

	try {
		const { data } = await extra.apiSmetNorms.getSsrCalcsTypes();
		dispatch(setSsrCalcTypes(data));
		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
